// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2Q6XJ","ThumbZoom":"ChapterPlayer_ThumbZoom__1KcQv"};